module.exports = __webpack_public_path__ + "img/insta.2cde0f4d.svg";